<template>
    <v-navigation-drawer v-bind:value="value" @input="input" :clipped="$vuetify.breakpoint.lgAndUp" app dark color="secondary">
        <!-- 관리자 목록 -->
        <v-list v-model="selected" dense>
            <template v-for="menu in menus">

                <!-- 싱글메뉴 -->
                <v-list-item-group v-if="!menu.children" v-model="selected" :key="menu.model">
                    <v-list-item v-if="menu.scope === undefined || menu.scope.find((scope) => payload.scope.includes(scope))" :key="menu.title" :value="menu" @click="navigate(menu)">
                        <template v-slot:default="{ active }">
                            <v-list-item-action>
                                <v-icon size="20" :color="active ? 'accent' : ''">{{ menu.icon }}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title class="text-start subtitle-2" :class="{ 'accent--text': active}">{{ menu.title }}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                    </v-list-item>
                </v-list-item-group>

                <!-- 자식이 있는 메뉴 -->
                <v-list-group v-else-if="menu.scope === undefined || menu.scope.find((scope) => payload.scope.includes(scope))" :key="menu.text" v-model="menu.model" :prepend-icon="menu.icon" color="white">
                    <template v-slot:prependIcon>
                        <v-icon size="20">{{ menu.icon }}</v-icon>
                    </template>
                    <template v-slot:activator>
                        <v-list-item-title class="text-start subtitle-2">{{ menu.title }}</v-list-item-title>
                    </template>
                    <v-divider></v-divider>

                    <v-list-item-group v-model="selected">
                        <template v-for="(child, j) in menu.children">
                            <v-list-item v-if="child.scope === undefined || child.scope.find((scope) => payload.scope.includes(scope))" :key="j" :value="child" @click="navigate(child)" style="background: #414958;" dense>
                                <template v-slot:default="{ active }">
                                    <v-list-item-action class="mr-4 ml-4">
                                        <v-icon v-if="child.icon" dense :color="active ? 'accent' : ''">{{ child.icon }}</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title class="text-start" :class="{ 'grey--text text--lighten-1': !active, 'accent--text': active }">{{ child.title }}</v-list-item-title>
                                    </v-list-item-content>
                                </template>
                            </v-list-item>
                        </template>
                    </v-list-item-group>

                    <v-divider></v-divider>
                </v-list-group>

            </template>
        </v-list>

        <!-- 관리자 하단 목록 -->
        <template v-slot:append>
            <v-divider></v-divider>
            <v-list dense class="pa-0">
                <v-list-item @click="signOut">
                    <v-list-item-action>
                        <v-icon size="20">mdi-logout-variant</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="text-start">로그아웃</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </template>

    </v-navigation-drawer>
</template>

<script>
import {
    mdiReceipt,
    mdiMessageText,
} from '@mdi/js';

export default {
    props: {
        value: { type: Boolean, default: null }
    },
    data() {
        return {
            mdiMessageText,

            selected: null,
            menus: [
                {
                    icon: "mdi-cart",
                    title: "쇼핑몰 정보",
                    children: [
                        {
                            title: "상품 관리",
                            route: {
                                path: "/console/shop/products"
                            }
                        },
                    ]
                },
                {
                    icon: mdiReceipt,
                    title: "주문 정보",
                    children: [
                        {
                            title: "주문 관리",
                            route: {
                                path: "/console/shop/purchases/order"
                            }
                        },
                        
                    ]
                },
            ]
        };
    },
    methods: {
        input(value){
            this.$emit('input', value);
        },
        signOut(){
            if(confirm("로그아웃 하시겠습니까?")){
                this.$store.dispatch('logout');
            }
        },
        navigate(item) {
            if(item.route) this.$router.push(item.route);
        },
    },
    computed: {
        payload(){
            return this.$store.state.payload || {};
        }
    }
}
</script>
